// extracted by mini-css-extract-plugin
module.exports = {"selected":"style__selected__Z1sav"};